import LCAPlot from './lca/LCAPlot';
import TEAPlot from './tea/TEAPlot';
import LCABreakdownPlot from './lca/LCABreakdownPlot';
import { useEffect, useRef } from 'react';
import TEABreakdownPlot from './tea/TEABreakdownPlot';
import ExportButton from '../core/ExportButton';
import { useIsAnalysisInProgress } from '@/stores/analysisStatusStore';
import { SensitivityAnalysisSection } from './SensitivityAnalysisSection';
import { PlantCharacteristicsSection } from './PlantCharacteristicsSection';

const Report = () => {
  const blockRef = useRef(null);
  const isAnalysisInProgress = useIsAnalysisInProgress();

  useEffect(() => {
    blockRef.current.focus();
  }, []);

  return (
    <div ref={blockRef} className="relative bg-canvas flex flex-col gap-1 px-4 pb-4 focus:outline-none" tabIndex={-1}>
      {!isAnalysisInProgress && <ExportButton />}

      <div className="grid gap-4 grid-cols-2">
        <LCAPlot />
        <TEAPlot />
      </div>

      <div className="border-t border-gray-200">
        <LCABreakdownPlot />
        <TEABreakdownPlot />
      </div>

      <PlantCharacteristicsSection />

      <div className="border-t border-gray-200">
        <SensitivityAnalysisSection />
      </div>
    </div>
  );
};

export default Report;
